'use client';

import { Toaster } from '@axon/ui';

export default function ToasterClient() {
  return <Toaster />;
}
